import { useState } from 'react';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import { FiDownload, FiCopy, FiTrash2 } from 'react-icons/fi';
import { MdArrowBackIosNew } from 'react-icons/md';
import { Link, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { useMediaQuery } from '@mui/material';
import { OButton, OPopper, OTooltip, OResponsiveModal } from '@src/shared';
import cn from 'classnames';

import DeleteModal from './DeleteModal/DeleteModal';
import InviteModal from './InviteModal';

import styles from '../webinarAttendees.module.scss';
import meetingCardStyles from '@src/components/ScheduledMeetingsView/partials/MeetingCard/meetingCard.module.scss';
import DeclinedAttendeesModal from './DeclinedAttendeesModal';
import { useDisableAfterBuffer, useRoomQuery } from '@src/hooks';
import { WEBINAR_STARTED_CHANGE_DISABLED } from '@src/constants';
import { useWebinarAttendees } from '@src/hooks';
import { isWebView } from '@src/helpers';
const AttendeesHeader = () => {
  const testComponentId = 'attendsHeader';
  const { id } = useParams();
  const { data: roomInfo } = useRoomQuery(id || '');

  const [open, setOpen] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [declinedModalOpen, setDeclinedModalOpen] = useState(false);
  const { data: declinedAttendees } = useWebinarAttendees(id!, {
    invitationStatus: 'declined',
    type: [],
    domain: [],
    country: [],
    company: [],
    search: '',
  });

  const isManagementDisabled = useDisableAfterBuffer(roomInfo?.startTime);
  const isMobileDevice = useMediaQuery('(max-width:768px)');

  const [isOptionsOpen, setIsOptionsOpen] = useState(false);

  return (
    <>
      <div className={styles['attends-header-container']}>
        {!isWebView() && (
          <div className={styles['attends-title-container']}>
            <Link to="/" color="primary" className={styles['attends-back-link']}>
              <MdArrowBackIosNew width={6} height={11} />
              Back
            </Link>
            <h1> v webinar attendees</h1>
            <span className={styles['secondary-title']}>Review and respond to webinar participant requests</span>
          </div>
        )}
        <div className={styles['header-action-container']}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <OTooltip
              title={isManagementDisabled ? WEBINAR_STARTED_CHANGE_DISABLED : ''}
              arrow
              placement="top"
              customStyles={{
                tooltip: {
                  backgroundColor: '#3E4756',
                  color: 'white',
                  fontSize: '12px',
                },
                arrow: {
                  color: '#3E4756',
                },
              }}
            >
              <div>
                <OButton
                  text="Send invite"
                  onClick={() => setOpen(true)}
                  outlined
                  size="x-small"
                  isDisabled={isManagementDisabled}
                  id={`${testComponentId}_sendInvatation`}
                />
              </div>
            </OTooltip>
            <OTooltip
              title={!declinedAttendees?.length ? 'No attendees have declined to join.' : ''}
              arrow
              placement="top"
              customStyles={{
                tooltip: {
                  backgroundColor: '#3E4756',
                  color: 'white',
                  fontSize: '12px',
                },
                arrow: {
                  color: '#3E4756',
                },
              }}
            >
              <div>
                <OButton
                  text={`Decline attendees (${declinedAttendees?.length || 0})`}
                  onClick={() => setDeclinedModalOpen(true)}
                  outlined
                  size="x-small"
                  id={`${testComponentId}_declineAttendees`}
                  isDisabled={!declinedAttendees?.length}
                />
              </div>
            </OTooltip>

            {isMobileDevice ? (
              <>
                <div
                  className={cn(styles['menu-dots'], {
                    [styles['activeDots']]: isOptionsOpen,
                  })}
                  onClick={() => {
                    setIsOptionsOpen(true);
                  }}
                >
                  <BiDotsHorizontalRounded size={16} />
                </div>
                <OResponsiveModal
                  isOpen={isOptionsOpen}
                  title="More"
                  onClose={() => setIsOptionsOpen(false)}
                  hasBackdrop
                >
                  <div className={meetingCardStyles.modalContent}>
                    <ul className={meetingCardStyles.optionsList}>
                      <li
                        className={meetingCardStyles.optionItem}
                        onClick={() => {
                          setIsOptionsOpen(false);
                        }}
                      >
                        <span className={meetingCardStyles.icon}>
                          <FiDownload />
                        </span>
                        <span>Export CSV</span>
                      </li>
                      <li
                        className={meetingCardStyles.optionItem}
                        onClick={() => {
                          setIsOptionsOpen(false);
                        }}
                      >
                        <span className={meetingCardStyles.icon}>
                          <FiCopy />
                        </span>
                        <span>Copy webinar invitation link</span>
                      </li>
                      <li
                        className={`${meetingCardStyles.optionItem} ${meetingCardStyles.delete}`}
                        onClick={() => {
                          setOpenConfirmModal(true);
                          setIsOptionsOpen(false);
                        }}
                      >
                        <span className={meetingCardStyles.icon}>
                          <FiTrash2 />
                        </span>
                        <span>Delete webinar</span>
                      </li>
                    </ul>
                  </div>
                </OResponsiveModal>
              </>
            ) : (
              <OPopper
                customStyles={{
                  root: {
                    width: '161px',
                    inset: '8px 0 auto auto !important',
                    border: 0,
                  },
                  boxRoot: {
                    background: 'var(--public-poper-bg) ',
                    border: '1px solid var(--border-poper) ',
                    color: 'var(--dark-title)',
                  },
                }}
                position="bottom-end"
                classes={{
                  iconButton: styles['btn-action'],
                }}
                icon={<BiDotsHorizontalRounded size={16} />}
                onOpen={() => setIsOptionsOpen(true)}
                onClose={() => setIsOptionsOpen(false)}
                offset={[0, 8]}
              >
                <div className={styles['menu-item']} onClick={() => {}}>
                  Export CSV
                </div>

                <div className={styles['menu-item']} onClick={() => {}}>
                  Copy webinar invitation link
                </div>

                <div
                  className={`${styles['menu-item']} ${styles['danger']} `}
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenConfirmModal(true);
                  }}
                >
                  Delete webinar
                </div>
              </OPopper>
            )}
          </div>
        </div>

        {id && (
          <DeleteModal openConfirmModal={openConfirmModal} onClose={() => setOpenConfirmModal(false)} meetingId={id} />
        )}
        <InviteModal open={open} title="Invite a Panelist" onClose={() => setOpen(false)} />
      </div>
      <ToastContainer position="top-right" autoClose={3500} />
      <DeclinedAttendeesModal
        isOpen={declinedModalOpen}
        onClose={() => setDeclinedModalOpen(false)}
        declinedAttendees={declinedAttendees}
      />
    </>
  );
};

export default AttendeesHeader;
